import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Layout,
  FormLayout,
  Card,
  Loading,
  Text,
  TextField,
  Tabs,
  Badge,
  PageActions,
  InlineStack,
  Banner,
  Toast,
  Icon,
  DropZone,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { accessSettings } from "../../Helpers";

const GoogleAnalytics = (props) => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [item, setItem] = useState({
    analyticsId: "",
    propertyId: "",
  });
  const handleChangeAnalyticsId = (newValue) => {
    setItem({ ...item, analyticsId: newValue });
  };
  const handleChangePropertyId = (newValue) => {
    setItem({ ...item, propertyId: newValue });
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [domainError, setDomainError] = useState("");
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts jsons"} />
  );
  const uploadedFile = file && (
    <InlineStack gap="200" align="start" blockAlign="center">
      {/* Uncomment if using thumbnail */}
      {/*
    <Thumbnail
      size="small"
      alt={file.name}
      source={
        validImageTypes.includes(file.type)
          ? window.URL.createObjectURL(file)
          : NoteMinor
      }
    />
    */}
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </InlineStack>
  );
  const sendImage = (file) => {};
  useEffect(() => {
    axios
      .get(`/settings/google-analytics`)
      .then((result) => {
        setIsSaving(false);
        setItem({
          analyticsId: result?.data?.data?.google_analytics_id
            ? result?.data?.data?.google_analytics_id
            : "",
          propertyId: result?.data?.analytics_property_id
            ? result?.data?.analytics_property_id
            : "",
        });
      })
      .catch((err) => console.log(err));
  }, []);
  const handleSave = () => {
    setIsSaving(true);
    const form_data = new FormData();

    form_data.append("google_analytics_id", item.analyticsId);
    file && form_data.append("analytics_service_file", file);
    form_data.append("analytics_property_id", item.propertyId);

    form_data.append("_method", "PATCH");
    axios
      .post(`/settings/google-analytics`, form_data)
      .then((res) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => {
        setDomainError(
          "The shopify domain must end with one of the following: .myshopify.com"
        );
        setIsSaving(false);
      });
  };
  return (
    accessSettings() && (
      <Page
        title="Google Analytics"
        narrowWidth
        backAction={{
          onAction: () => navigate(`/admin/settings/integrations`),
        }}
      >
        <Card sectioned>
          {isSaving ? <Loading /> : null}
          <FormLayout>
            <TextField
              value={item.analyticsId}
              onChange={handleChangeAnalyticsId}
              label="Google Analytics Id"
            />
            <TextField
              value={item.propertyId}
              onChange={handleChangePropertyId}
              label="Property Id"
            />
            <Text as="p" fontWeight="regular">
              JSON File
            </Text>
            <DropZone
              accept=".json"
              //   type="file"
              allowMultiple={false}
              onDrop={handleDropZoneDrop}
              onDropAccepted={sendImage}
            >
              {uploadedFile}
              {fileUpload}
            </DropZone>
          </FormLayout>
        </Card>
        <PageActions
          primaryAction={{
            content: "Save",
            onClick: handleSave,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
      </Page>
    )
  );
};

export default GoogleAnalytics;
